// extracted by mini-css-extract-plugin
export default {"workflowIcon":"workflowIcon-o3ACH","popover":"popover-nAm52"};